const useConsoleVersion = (): void => {
  // console.log(`App Environment: "${process.env.NODE_ENV}"`)
  if (process.env.NEXT_PUBLIC_VERSION) {
    console.info(`App version: "${process.env.NEXT_PUBLIC_VERSION}"`)
  }
}
export default useConsoleVersion
